export default "__VITE_ASSET__CbEOGA1r__"